// # cx — 클래스 이름 잇기(clsx 와 같은 일)
//
// 거짓 값은 빼고 공백으로 잇는다. 변형은 `data-*` 속성이 가르므로(docs/design.md) 여기서
// 유틸리티 충돌을 풀 일이 없다 — tailwind-merge 가 하는 일이 애초에 필요 없다.

export type ClassPart = string | false | null | undefined

export const cx = (...parts: ClassPart[]): string => parts.filter(Boolean).join(' ')
